import { modifier } from 'ember-modifier';

export interface OnMoveOutsideSignature {
  Element: Element;
  Args: {
    Positional: [callback: (elem: Element) => void];
  };
}

// Shamelessly stolen from the on-click-outside modifier in the Ember tutorial, which is simple, elegant, and brilliant. ;)

const onMoveOutside = modifier<OnMoveOutsideSignature>((element: Element, [callback]: [(arg: Element) => void]) => {
  function handleMouseMove(event: MouseEvent) {
    if (event.target instanceof Element) {
      if (!element.contains(event.target)) {
        callback(event.target);
      }
    }
  }

  document.addEventListener('mousemove', handleMouseMove);
  return () => {
    document.removeEventListener('mousemove', handleMouseMove);
  };
});
export default onMoveOutside;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'on-move-outside': typeof onMoveOutside;
  }
}
